import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import { dyn, scheduleForCleanup } from "trader.ts/ui";
import * as style from "../../styles/style.css.classes";
import { Field, Parsing, syncRawAndParsing } from "trader.ts/ui.forms";
import { sleep } from "../lib/sleep";
import { renderSavingIndicator } from "../lib/textboxwithautosave";
import { fileb64 } from "../lib/base64";
import {
  arrayBufferToBase64Client,
  base64ToArrayBufferClient,
} from "../lib/arraybuffertobase64";
import { image_id } from "../../sql/classy/types";
import { isNumber } from "../lib/istype";

export function fileInputField(opts: {
  initial: { filename: string } | null;
  label: string;
  initiallabel: string | HTMLElement;
  selectedlabel: string;
  style?: string;
  className?: string;
  accept?: string;
}): Field<
  | null
  | { tag: "remove_existing" }
  | {
      tag: "new";
      file: {
        data: fileb64;
        mimetype: string;
        name: string;
      };
    }
> {
  const rawS: Source<{
    data: ArrayBuffer;
    mimetype: string;
    name: string;
  } | null> = new Source(null);

  const parsingS: Source<
    Parsing<
      | null
      | { tag: "remove_existing" }
      | {
          tag: "new";
          file: {
            data: fileb64;
            mimetype: string;
            name: string;
          };
        }
    >
  > = new Source({ tag: "parsed", parsed: null });

  syncRawAndParsing({
    rawS,
    parsingS,
    parse: (s) =>
      s === null
        ? { tag: "parsed" as const, parsed: null }
        : {
            tag: "parsed" as const,
            parsed: {
              tag: "new" as const,
              file: {
                data: arrayBufferToBase64Client(s.data),
                name: s.name,
                mimetype: s.mimetype,
              },
            },
          },
    parsedToRaw: (p) =>
      p === null
        ? null
        : p.tag === "new"
        ? {
            data: base64ToArrayBufferClient(p.file.data),
            name: p.file.name,
            mimetype: p.file.mimetype,
          }
        : p.tag === "remove_existing"
        ? null
        : null,
  });

  function render() {
    return (
      <article>
        <label for="">{opts.label}</label>
        <div
          className={style.input_like}
          style="display: flex; flex-direction: column; align-items: flex-start;"
        >
          {opts.initial ? (
            <div style="margin-bottom: 16px;">
              <b>
                {"Huidig: %filename".replace(
                  "%filename",
                  opts.initial.filename,
                )}
              </b>
            </div>
          ) : (
            ""
          )}
          {dyn(parsingS, (parsing) => {
            console.log(JSON.stringify(parsing));
            if (
              parsing.tag === "parsed" &&
              parsing.parsed &&
              parsing.parsed.tag === "remove_existing"
            ) {
              return (
                <div style="display: flex; width: 100%;">
                  <div style="flex: 1; font-weight: bold; color: red;">
                    {"Zal worden verwijderd"}
                  </div>
                  <button
                    onclick={() =>
                      parsingS.set({ tag: "parsed", parsed: null })
                    }
                  >
                    {"Annuleer"}
                  </button>
                </div>
              );
            } else if (
              parsing.tag === "parsed" &&
              parsing.parsed &&
              parsing.parsed.tag === "new"
            ) {
              return (
                <div style="display: flex; width: 100%;">
                  <div style="flex: 1; font-weight: bold;">
                    {"Nieuw" + ": " + parsing.parsed.file.name}
                  </div>
                  <button
                    onclick={() =>
                      parsingS.set({ tag: "parsed", parsed: null })
                    }
                  >
                    {"Annuleer"}
                  </button>
                </div>
              );
            } else {
              return (
                <div style="display: flex; width: 100%;">
                  <div style="flex: 1"></div>
                  {opts.initial ? (
                    <button
                      style="margin-right: 16px;"
                      className={style.button_white}
                      onclick={() =>
                        parsingS.set({
                          tag: "parsed",
                          parsed: { tag: "remove_existing" },
                        })
                      }
                    >
                      {"Verwijder"}
                    </button>
                  ) : (
                    []
                  )}
                  {renderFileInput({
                    source: rawS,
                    initiallabel: opts.initiallabel,
                    selectedlabel: opts.selectedlabel,
                    style: opts.style,
                    className: opts.className,
                    accept: opts.accept,
                  })}
                </div>
              );
            }
          })}
        </div>
      </article>
    );
  }

  return { s: parsingS, render, cleanup: () => {} };
}

export function fileInputFieldForImage(opts: {
  initial:
    | {
        data: fileb64;
        mimetype: string;
        name: string;
      }
    | image_id
    | null;
  label: string;
  initiallabel: string | HTMLElement;
  selectedlabel: string;
  mkImageLink: (id: image_id) => string;
  style?: string;
  className?: string;
  accept?: string;
}): Field<
  | null
  | image_id
  | {
      data: fileb64;
      mimetype: string;
      name: string;
    }
> {
  const rawS: Source<{
    data: ArrayBuffer;
    mimetype: string;
    name: string;
  } | null> = new Source(null);

  const parsingS: Source<
    Parsing<
      | null
      | image_id
      | {
          data: fileb64;
          mimetype: string;
          name: string;
        }
    >
  > = new Source({ tag: "parsed", parsed: opts.initial });

  syncRawAndParsing({
    rawS,
    parsingS,
    parse: (s) =>
      s === null
        ? { tag: "parsed" as const, parsed: null }
        : {
            tag: "parsed" as const,
            parsed: {
              data: arrayBufferToBase64Client(s.data),
              name: s.name,
              mimetype: s.mimetype,
            },
          },
    parsedToRaw: (p) =>
      p === null
        ? null
        : isNumber(p)
        ? null
        : {
            data: base64ToArrayBufferClient(p.data),
            name: p.name,
            mimetype: p.mimetype,
          },
  });

  function render() {
    return (
      <article>
        <label for="">{opts.label}</label>
        <div
          className={style.input_like}
          style="display: flex; align-items: flex-start;"
        >
          {dyn(parsingS, (parsing) => {
            console.log(JSON.stringify(parsing));
            if (parsing.tag === "parsed") {
              if (parsing.parsed === null) {
                return (
                  <div>
                    {renderFileInput({
                      source: rawS,
                      initiallabel: opts.initiallabel,
                      selectedlabel: opts.selectedlabel,
                      style: opts.style,
                      className: opts.className,
                      accept: opts.accept,
                    })}
                  </div>
                );
              } else if (isNumber(parsing.parsed)) {
                return [
                  <img
                    style="height: 128px; width: auto;"
                    src={opts.mkImageLink(parsing.parsed)}
                  ></img>,
                  <button
                    onclick={() =>
                      parsingS.set({ tag: "parsed", parsed: null })
                    }
                  >
                    {"Verwijder"}
                  </button>,
                ];
              } else {
                return [
                  <img
                    style="height: 128px; width: auto;"
                    src={"data:image/png;base64, " + parsing.parsed.data}
                  ></img>,
                  <button
                    onclick={() =>
                      parsingS.set({ tag: "parsed", parsed: null })
                    }
                  >
                    {"Verwijder"}
                  </button>,
                ];
              }
            } else {
              // Should never be here afaik?
              return (
                <div style="display: flex; width: 100%;">
                  <div style="flex: 1"></div>
                  {renderFileInput({
                    source: rawS,
                    initiallabel: opts.initiallabel,
                    selectedlabel: opts.selectedlabel,
                    style: opts.style,
                    className: opts.className,
                    accept: opts.accept,
                  })}
                </div>
              );
            }
          })}
        </div>
      </article>
    );
  }

  return { s: parsingS, render, cleanup: () => {} };
}

export function renderFileInput(opts: {
  source: Source<{ data: ArrayBuffer; mimetype: string; name: string } | null>;
  initiallabel: string | HTMLElement;
  selectedlabel: string;
  style?: string;
  className?: string;
  accept?: string;
  setLoading?: () => void;
  savedS?: Source<Parsing<null>>;
}) {
  const inp = (
    <input type="file" accept={opts.accept || "*"}></input>
  ) as HTMLInputElement;
  const handler = function () {
    const files = inp.files;
    if (files !== null && files[0]) {
      const file = files[0];
      if (opts.setLoading) {
        opts.setLoading();
      }
      void file.arrayBuffer().then(function (b) {
        opts.source.set({
          name: file.name,
          mimetype: file.type,
          data: b,
        });
      });
    } else {
      opts.source.set(null);
    }
  };
  inp.addEventListener("input", handler);
  scheduleForCleanup(() => inp.removeEventListener("input", handler));
  return dyn(opts.source, function (file) {
    if (file === null) {
      return (
        <label className={style.file_input}>
          {inp}
          <div
            style={opts.style + ";display: inline-flex;"}
            className={opts.className || style.button}
          >
            {opts.savedS
              ? renderSavingIndicator(opts.savedS, {
                  style: "margin-right: 16px;",
                })
              : []}
            {opts.initiallabel}
          </div>
        </label>
      );
    } else {
      return (
        <div>
          <label className={style.file_input}>
            {inp}
            <div
              style={opts.style + ";display: inline-flex;"}
              className={opts.className || style.button}
            >
              {opts.savedS
                ? renderSavingIndicator(opts.savedS, {
                    style: "margin-right: 16px;",
                  })
                : []}
              {opts.selectedlabel}: {file.name}
            </div>
          </label>
        </div>
      );
    }
  });
}

export function fileboxWithAutosave(opts: {
  doSave: (file: {
    data: ArrayBuffer;
    mimetype: string;
    name: string;
  }) => Promise<unknown>;
  initiallabel: string | HTMLElement;
  selectedlabel: string;
  style?: string;
  className?: string;
  onSave?: () => unknown;
}) {
  const fileS = new Source<{
    data: ArrayBuffer;
    mimetype: string;
    name: string;
  } | null>(null);

  let savei = 0;
  scheduleForCleanup(
    fileS.observe((file) => {
      if (file !== null) {
        savei++;
        const myi = savei;
        savedS.set({ tag: "loading" });
        opts
          .doSave(file)
          .then(() => {
            savedS.set({ tag: "parsed", parsed: null });
            if (opts.onSave) {
              opts.onSave();
            }
          })
          .catch(() => savedS.set({ tag: "err" }))
          .finally(async () => {
            await sleep(1500);
            // To avoid race conditions
            if (myi === savei) {
              savedS.set({ tag: "initial" });
            }
          });
      }
    }),
  );

  const savedS: Source<Parsing<null>> = new Source({ tag: "initial" });

  const input = renderFileInput({
    source: fileS,
    ...opts,
    savedS,
    setLoading: () => {
      savedS.set({ tag: "loading" });
    },
  });

  return input;
}
